import { useNovel } from '@/context/novel-context';
import { useMemo } from 'react';

import { EntitySummary } from '@/lib/types';
import { toTimestamp } from '@/lib/date-utils';

interface UseLocationsReturn {
  locations: EntitySummary[];
  isLoading: boolean;
  error: Error | null;
}

/**
 * Hook to fetch all locations for the current novel from summaries.
 */
export function useLocations(): UseLocationsReturn {
  const { novel, isLoading, error } = useNovel();

  const locations = useMemo(() => {
    const summaryMap = novel.summaries.locations;
    return Object.values(summaryMap)
      .sort((a, b) => {
        const dateA = toTimestamp(a.updatedAt);
        const dateB = toTimestamp(b.updatedAt);
        return dateB - dateA;
      });
  }, [novel]);

  return {
    locations,
    isLoading,
    error: error as Error | null,
  };
}
